export type TypeByField = 'unknown' | 'code' | 'name' | 'otherName' | 'desc' | 'employeeId' | 'address' | 'postcode' | 'phoneNo' | 'ipAddress' | 'macAddress';
export type TypeByRule = 'email' | 'alphabets' | 'alphanumeric' | 'unicode' | 'space' | 'hyphen' | 'apostrophe' | 'underscore' | 'comma' | 'fullstop' | 'forwardSlash' | 'hashtag' | 'phoneNo';

//actual regex that sets input restrictions
export const patternParts: Record<TypeByRule, { pattern: string; noConsecutive?: boolean }> = {
    email: { pattern: "A-Za-z0-9._%+\\-@" },
    alphabets: { pattern: 'a-zA-Z' }, //excludes unicode
    alphanumeric: { pattern: 'a-zA-Z0-9' },
    unicode: { pattern: '\\p{L}' }, //includes alphabets
    space: { pattern: ' ', noConsecutive: true },
    hyphen: { pattern: '\\-', noConsecutive: true },
    apostrophe: { pattern: "'", noConsecutive: true },
    underscore: { pattern: "_", noConsecutive: true },
    comma: { pattern: ",", noConsecutive: true },
    fullstop: { pattern: "\\.", noConsecutive: true },
    forwardSlash: { pattern: "/", noConsecutive: true },
    hashtag: { pattern: "#", noConsecutive: true },
    phoneNo: { pattern: "0-9+\\-()", noConsecutive: false },
};

//predefined rules for each field
export const fieldPatterns: Record<TypeByField, TypeByRule[]> = {
    unknown: [],
    code: [],
    // name: ['unicode', 'space', 'hyphen', 'apostrophe'],
    // otherName: ['unicode', 'space', 'hyphen', 'apostrophe'],
    name: [],
    otherName: [],
    desc: [],
    // employeeId: ['alphanumeric', 'underscore', 'hyphen'],
    // address: ['alphanumeric', 'space', 'comma', 'fullstop', 'hyphen', 'forwardSlash', 'hashtag'],
    // postcode: ['alphanumeric', 'space'],
    employeeId: [],
    address: [],
    postcode: [],
    phoneNo: ['phoneNo'],
    ipAddress: [],
    macAddress: [],
};

export const fieldConstraints: Record<TypeByField, { maxLength?: number }> = {
    unknown: {},
    code: { maxLength: 20 },
    name: { maxLength: 100 },
    otherName: { maxLength: 100 },
    desc: { maxLength: 500 },
    employeeId: {},
    address: { maxLength: 255 },
    postcode: { maxLength: 10 },
    phoneNo: { maxLength: 15 },
    ipAddress: { maxLength: 45 },
    macAddress: { maxLength: 17 },
};